import { typeCreatorV2 } from 'redux/utils/common';

export const SET_CLIENT_DOCUMENTS: string = typeCreatorV2(
  'ClientDocumentsReducer',
  'SetClientDocuments'
);

export const INSERT_CLIENT_DOCUMENT: string = typeCreatorV2(
  'ClientDocumentsReducer',
  'InsertClientDocuments'
);

export const SET_SELECTED_DOCUMENT: string = typeCreatorV2(
  'ClientDocumentsReducer',
  'SetSelectedDocuments'
);

export const REARRANGE_DOCUMENTS: string = typeCreatorV2(
  'ClientDocumentsReducer',
  'RearrangeDocuments'
);

export const UPDATE_DOCUMENT_VISIBILITY: string = typeCreatorV2(
  'ClientDocumentsReducer',
  'UpdateDocumentVisibility'
);

export const DELETE_DOCUMENT: string = typeCreatorV2(
  'ClientDocumentsReducer',
  'DeleteDocument'
);

export const SET_DOCUMENT_INFO: string = typeCreatorV2(
  'ClientDocumentsReducer',
  'SetDocumentInfo'
);

export const UPDATE_DOCUMENT_INFO: string = typeCreatorV2(
  'ClientDocumentsReducer',
  'UpdateDocumentInfo'
);
